import type { TourDefinition, TourStep } from './types';

const addBabyStep: TourStep = {
    id: 'mypetito.addbaby',
    target: [
        '[data-tour-id="mypetito.addbaby.empty"]',
        '[data-tour-id="mypetito.addbaby"]',
    ],
    titleKey: 'tour.mypetito.addbaby.title',
    bodyKey: 'tour.mypetito.addbaby.body',
    titleFb: 'Add your baby',
    bodyFb: 'Start with your child or expected arrival so we can personalise tips.',
    // auto flips top/bottom so we never cover the + Add baby pill after scroll
    placement: 'auto',
    spotlightPadding: 3,
};

const fullSteps: TourStep[] = [
    addBabyStep,
    {
        id: 'mypetito.checklist',
        target: ['[data-tour-id="mypetito.checklist"]'],
        titleKey: 'tour.mypetito.checklist.title',
        bodyKey: 'tour.mypetito.checklist.body',
        titleFb: 'Checklist',
        bodyFb: 'Tick what you still need — open items power smarter matches.',
        placement: 'top',
        spotlightPadding: 4,
    },
    {
        id: 'mypetito.results',
        // Two separate rings: Find CTA + recommendations block (same step)
        target: [
            '[data-tour-id="mypetito.find"]',
            '[data-tour-id="mypetito.results"]',
        ],
        highlightAllTargets: true,
        titleKey: 'tour.mypetito.results.title',
        bodyKey: 'tour.mypetito.results.body',
        titleFb: 'Find matches',
        bodyFb: 'Find shows listings based on open checklist items for this phase.',
        // Card above bottom nav; primary scroll target is Find
        placement: 'top',
        anchor: 'bottom-nav',
        anchorGapPx: 8,
        spotlightPadding: 3,
    },
];

/** When no child yet: checklist/Find are not in the DOM — teach empty state instead. */
const emptySteps: TourStep[] = [
    addBabyStep,
    {
        id: 'mypetito.empty',
        target: [
            '[data-tour-id="mypetito.empty"]',
            '[data-tour-id="mypetito.addbaby.empty"]',
            '[data-tour-id="mypetito.addbaby"]',
        ],
        titleKey: 'tour.mypetito.empty.title',
        bodyKey: 'tour.mypetito.empty.body',
        titleFb: 'Your journey hub',
        bodyFb:
            'After you add a baby, checklists and Find will match gear for their age and open items.',
        placement: 'top',
    },
    {
        id: 'mypetito.help',
        target: ['[data-tour-id="tour.help"]'],
        titleKey: 'tour.home.help.title',
        bodyKey: 'tour.home.help.body',
        titleFb: 'Need a refresher?',
        bodyFb: 'Tap the ? anytime to replay this tour.',
        placement: 'bottom',
    },
];

/** My Petito page coachmarks: add baby → checklist → recommendations. */
export const myPetitoTour: TourDefinition = {
    id: 'mypetito',
    steps: fullSteps,
};

/** Resolve steps from live DOM (empty vs has child / checklist). */
export function getMyPetitoSteps(): TourStep[] {
    if (typeof document === 'undefined') return fullSteps;
    const hasChecklist = !!document.querySelector('[data-tour-id="mypetito.checklist"]');
    return hasChecklist ? fullSteps : emptySteps;
}
